import { Screen } from 'constants/tracking/screens'
import useTranslate from 'hooks/useTranslate'
import HelpCenterHome from 'pages/HelpCenter/HelpCenterHome'

import PageHead from '../../components/Head/PageHead'
import fullPageLayout from '../../layouts/FullPage'
import { getLayoutServerSideProps } from '../../layouts/FullPage/server-props'
import { emptyPropsCallback } from '../../libs/server-utils/ssr'

const HelpCenter = () => {
  const translate = useTranslate()

  return (
    <>
      <PageHead title={translate('help_center.page_title')} />
      <div className="regular-container">
        <HelpCenterHome />
      </div>
    </>
  )
}

export default fullPageLayout(HelpCenter)

export const getServerSideProps = getLayoutServerSideProps(emptyPropsCallback, {
  screen: Screen.HelpCenterHome,
})
